import * as React from 'react';
import { IconButton, Box } from '@mui/material';
import { PhotoCamera } from '@mui/icons-material';
import { observer } from 'mobx-react-lite';
import { storeNewsImage } from '../../firebaseConnection/storage';
import { NewsWithRoleName } from '../../store/NewsStore';

const UploadButton = observer(
  ({
    newsElement,
    updateImage,
  }: {
    newsElement: NewsWithRoleName;
    updateImage: () => void;
  }): JSX.Element => {
    const captureFile: React.ChangeEventHandler<HTMLInputElement> = async ({
      target: input,
    }) => {
      if (input.files) {
        const timeStamp = new Date().getTime();
        await storeNewsImage(timeStamp, input.files[0]);
        await newsElement.setImageFileName(`${timeStamp.toString()}.jpg`);
        updateImage();
      }
    };

    return (
      <Box
        alignItems="center"
        display="flex"
        justifyContent="center"
        flexDirection="column"
      >
        <Box>
          <label htmlFor={`upload-company-logo-${newsElement.roleName}`}>
            <input
              accept="image/*"
              id={`upload-company-logo-${newsElement.roleName}`}
              type="file"
              hidden
              onChange={captureFile}
            />
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
            >
              <PhotoCamera />
            </IconButton>
          </label>
        </Box>
      </Box>
    );
  },
);

export default UploadButton;
